export default __webpack_public_path__ + "static/media/driver_licence.c111ec5c.jpg";